var map = {
	"./DFDC-logo.png": 4028,
	"./DFDG-logo.png": 5888,
	"./DL-logo.png": 8024,
	"./DRAGON-LINK-logo.png": 9649,
	"./DRAGONS-FOO-logo.png": 7184,
	"./FD-logo.png": 1803,
	"./FORTUNE-DRAGON-logo.png": 891,
	"./GF-logo.png": 1011,
	"./JJBX-logo.png": 5828,
	"./JJBXG-logo.png": 9360,
	"./JLTF-logo.png": 8449,
	"./LIGHTNING-LINK-logo.png": 9839,
	"./LL-logo.png": 3829,
	"./MVP-logo.png": 5667,
	"./TCJL-logo.png": 7443,
	"./YCS-logo.png": 1648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8837;